import { AvailableGlobalPermissions, AvailablePermissionsValue, RequiredPermissions } from 'features/validateAccess';

export const UPDATE_COUNTRY: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.COUNTRIES,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];
